import { handleResponse, authHeader } from '../_helpers';
import { config, GOOGLE_API_KEY_AUTOCOMPLETE, SEARCH_POSTAL_CODE } from "../../common/constant";
import { getPaymentEndpoint } from '../../common';
import { captureApiError } from '../../common';

export const EnrollService = {
    enrollDonorManuallyPreDonation,
    getPostalCodeFromGoogleAPI,
    confirmSignpassDetails,
    getUserDataFromNRIC,
    checkMobileNoExists,
    registerCognitoUser,
    updateCognitoUser,
    getUserData,
    getPostalCode,
    updateDonorCognitoProfile,
    updateDonorEmailCognitoProfile
};

async function getUserDataFromNRIC(nric) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    requestOptions.headers['uuid'] = nric;
    const version = getPaymentEndpoint();
    const url = config.BASE_URL_DOMAIN + `/donor-${version}/api/User/getLastTxnDonorDetailsByNric`;
    
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result.data;
            } else {
                return result.data
            }
        }).catch(error => {
            captureApiError(error)
            return [];
        });
}

async function checkMobileNoExists(payload, nric) {
    const version = getPaymentEndpoint();
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: authHeader()
    };

    requestOptions.headers['uuid'] = nric;

    const url = config.BASE_URL_DOMAIN + `/donor-${version}/api/User/checkCognitoMobileExists`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result.data;
            } else {
                return result.data
            }
        }).catch(error => {
            captureApiError(error)
            return [];
        });
}

async function enrollDonorManuallyPreDonation(payload) {
    const version = getPaymentEndpoint();
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: authHeader()
    };

    const url = config.BASE_URL_DOMAIN + `/donor-${version}/api/User/enrollDonorManuallyPreDonation`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result.data;
            } else {
                return result.data
            }
        }).catch(error => {
            captureApiError(error)
            return [];
        });
}

async function confirmSignpassDetails(confirmSingpassPayload) {
    const version = getPaymentEndpoint();
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(confirmSingpassPayload),
        headers: authHeader()
    };

    const url = config.BASE_URL_DOMAIN + `/donor-${version}/api/User/confirmSingpassPreDonation`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            return result.data;
        }).catch(error => {
            captureApiError(error)
            return { status: 0 };
        });
}


async function getUserData(data) {
    const version = getPaymentEndpoint();
    let headers = authHeader()
    headers['Content-Type'] = 'application/json'

    const requestOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
    };
    const url = config.BASE_URL_DOMAIN + `/donor-${version}/api/User/getDonorByTransactionNumber`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            return result.data;
        }).catch(error => {
            captureApiError(error)
            return { status: 0 };
        });
}

async function getPostalCodeFromGoogleAPI(lat, lan) { 
    const requestOptions = { 
        method: 'GET', 
    }; 

    const url = config.GOOGLE_POSTAL_CODE_BASE_URL + `/api/geocode/json?latlng=${lat},${lan}&key=${GOOGLE_API_KEY_AUTOCOMPLETE}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            if (result.status == 'OK')
                return result.results[0];
            else
                return { status: 0 };
        }).catch(error => {
            captureApiError(error)
            return { status: 0 };
        });
}

async function registerCognitoUser({ uniqueUserId, phoneCountryCode, phoneNumber, email}) {
    const version = getPaymentEndpoint();
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ uniqueUserId, phoneCountryCode, phoneNumber, email})
    };

    const URL = config.BASE_URL_DOMAIN + `/donor-${version}/api/User/registerCognitoUser`;

    requestOptions.headers['uuid'] = uniqueUserId;

    try {
        const res = await fetch(URL, requestOptions);
        const result = await handleResponse(res)

        return result.data;
    } catch (err) {
        captureApiError(err)
        return { status: 0, message: err.message };
    }
}

async function updateCognitoUser({ uniqueUserId, phoneCountryCode, phoneNumber}) {
    const version = getPaymentEndpoint();
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ phoneCountryCode, phoneNumber})
    };

    const URL = config.BASE_URL_DOMAIN + `/donor-${version}/api/User/updateCognitoUser`;

    requestOptions.headers['uuid'] = uniqueUserId;

    try {
        const res = await fetch(URL, requestOptions);
        const result = await handleResponse(res)

        return result.data;
    } catch (err) {
        captureApiError(err)
        return { status: 0, message: err.message };
    }
}

// Update cognito user profile details
async function updateDonorCognitoProfile(payload) {
    const version = getPaymentEndpoint();
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };

    const URL = config.BASE_URL_DOMAIN + `/donor-${version}/api/User/updateDonorCognitoProfile`;

    requestOptions.headers['uuid'] = btoa(payload.uniqueUserId);

    try {
        const res = await fetch(URL, requestOptions);
        const result = await handleResponse(res)

        return result.data;
    } catch (err) {
        captureApiError(err)
        return { status: 0, message: err.message };
    }
}

// Update cognito user profile email
async function updateDonorEmailCognitoProfile(payload) {
    const version = getPaymentEndpoint();
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };

    const URL = config.BASE_URL_DOMAIN + `/donor-${version}/api/User/updateDonorEmailCognitoProfile`;

    requestOptions.headers['uuid'] = btoa(payload.uniqueUserId);

    try {
        const res = await fetch(URL, requestOptions);
        const result = await handleResponse(res)

        return result.data;
    } catch (err) {
        captureApiError(err)
        return { status: 0, message: err.message };
    }
}

async function getPostalCode(payload) {
    if(!payload) return;
    const requestOptions = {
      method: "GET",
      headers: authHeader(true)
    };

    const url = SEARCH_POSTAL_CODE +`/elastic/search?returnGeom=N&getAddrDetails=Y&searchVal=${payload}`

    return fetch(url, requestOptions)
      .then(handleResponse)
      .then((result) => {
        if (
          result !== null &&
          result !== undefined
        ) {
          return result;
        } else {
          return false;
        }
      })
      .catch((error) => {
        captureApiError(error)
        return false;
      });
}